import { AdminRole } from "@repo/api-dtos"
import { useQuery } from "@tanstack/react-query"
import { useMarketplaceOrpc } from "@/integrations/orpc/marketplace-react"

export function useAdminRoles() {
	const { orpc, isAuthReady } = useMarketplaceOrpc()

	const { data, isLoading, error } = useQuery({
		...orpc.rbac.getMyRoles.queryOptions(),
		enabled: isAuthReady,
		staleTime: 5 * 60 * 1000,
	})

	const roles = data?.roles ?? []

	const hasRole = (role: AdminRole) =>
		roles.includes(AdminRole.Superadmin) || roles.includes(role)

	const hasAnyRole = (requiredRoles: AdminRole[]) =>
		roles.includes(AdminRole.Superadmin) ||
		requiredRoles.some((r) => roles.includes(r))

	const isSuperadmin = roles.includes(AdminRole.Superadmin)

	return { roles, isLoading, error, hasRole, hasAnyRole, isSuperadmin }
}
